import { cn } from "@/lib/utils";
import { ChatMarkdownBody } from "@/components/chat/ChatMarkdownBody";

type VeeraThreadSpeaker = "coach" | "leader" | "you" | "veera";

interface VeeraThreadMessageProps {
  role: VeeraThreadSpeaker;
  text: string;
  className?: string;
}

const speakerLabels: Record<VeeraThreadSpeaker, string> = {
  coach: "Coach",
  leader: "Leader",
  you: "You",
  veera: "Veera",
};

export function VeeraThreadMessage({ role, text, className }: VeeraThreadMessageProps) {
  const isVeera = role === "veera";
  return (
    <article className={cn("space-y-1.5", className)}>
      <p className="text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">
        {speakerLabels[role]}
      </p>
      {isVeera ? <ChatMarkdownBody content={text} /> : <p className="text-sm leading-relaxed text-foreground">{text}</p>}
    </article>
  );
}
